import type { ProjectListParams } from '@/api/types'
import { flag, readSearch, text } from '@/lib/search-params'

/** Filtres de la liste des projets, portés par l'URL sur la page globale. */
const SHAPE = {
  q: text(),
  client: text(),
  responsable: text(),
  /** Projets terminés et annulés : masqués par défaut, comme le serveur. */
  clos: flag(),
}

export interface ProjectsSearch {
  q?: string | undefined
  client?: string | undefined
  responsable?: string | undefined
  clos?: boolean | undefined
}

export function parseProjectsSearch(search: Record<string, unknown>): ProjectsSearch {
  return readSearch(SHAPE, search)
}

export function toProjectListParams(search: ProjectsSearch): ProjectListParams {
  const q = search.q?.trim()
  return {
    q: q === '' ? undefined : q,
    client_id: search.client,
    owner_id: search.responsable,
    include_closed: search.clos ?? false,
    page_size: 200,
  }
}
